import file from './file';
import folder from './folder';

export const contentTypes = {
  file,
  folder,
};
